<template>
  <div class="detail-container">
    <div class="license-detail-box columns is-multiline is-centered is-12">
      <div class="column is-9">
        <div class="license-title has-text-weight-bold">{{ this.$store.state.detailPage.licenseType }}</div>
        <div class="license-number is-size-2">License Number: <b> {{ this.$store.state.detailPage.licenseNumber }} </b></div>
        <div
          class="license-address has-text-weight-bold"
        >
         L&I District:  {{this.$store.state.searchResults.li_district}}
        </div>
        <div
          class="license-address has-text-weight-bold"
        >
          OPA Account #:  {{this.$store.state.detailPage.opa_account_num}}
        </div>
        <div 
          class="license-address"
          v-for="item in this.$store.state.detailPage.licenseAddress"
          :key="item"
        >
          <div class="multi-cell">
            {{ item }} 
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="license-date has-text-weight-bold">{{ this.$store.state.detailPage.licenseStatus }} </div>
        <div class="bottom-right-link">
        </div>
      </div>
    </div>

    <div
      class="detail-table-container columns is-multiline is-centered is-12"
    >
      <v-client-table 
        class="table-light no-header column is-12"
        :data="tableData" 
        :columns="columns" 
        :options="options"
      >
        <template
          slot="appealTableInfo"
          slot-scope="{row}"
          class="multi-cell"
        >

        <!-- single-line cell template -->
        <div v-if="(typeof row.appealTableInfo === 'string') && (row.id !== 'Zoning documents')">
          <div
            class="multi-cell"
          >
            {{ row.appealTableInfo }}
          </div>
        </div>

        <!-- multi-line cell template -->
        <div 
          v-if="(typeof row.appealTableInfo === 'object') && (row.id !== 'Zoning documents')"
        >
          <div 
            v-for="item in row.appealTableInfo"
            :key="item"
          >
            <div
              class="multi-cell"
            >
              {{ item }} 
            </div>
          </div>
        </div>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'licenseDetail',
  data() {
    return {
      detailInfo: this.$store.state.detailPage,
      columns: ['id', 'appealTableInfo'],
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: { 
          show: false, 
          virtual: false,
        },
        perPage: 100,

        columnsClasses: {
          id: 'license table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  destroyed() {
    this.$store.commit('closeDetail');
  },
  computed: {
    tableData(){
      let tableInfo = [
        // { id: "Owner name", 
        //   appealTableInfo: this.detailInfo.licenseOwner
        // },
        // { id: "Owner mailing address", 
        //   appealTableInfo: this.detailInfo.BusinessMailingAddress
        // },
        { id: "License number", 
          appealTableInfo: this.detailInfo.licenseNumber
        },
        { id: "License type", 
          appealTableInfo: this.detailInfo.licenseUnits ? this.detailInfo.licenseType +  " (" + this.pluralize(this.detailInfo.licenseUnits) + ")" : this.detailInfo.licenseType
        },
        { id: "Rental category", 
          appealTableInfo: this.detailInfo.rentalCategory ? this.detailInfo.rentalCategory : 'Not Available'
        },
        { id: "Status", 
          appealTableInfo: this.detailInfo.licenseStatus
        },
        { id: "Date issued", 
          appealTableInfo: moment(this.detailInfo.licenseDateIssued).isValid() ? moment(this.detailInfo.licenseDateIssued).format('MMM DD, yyyy') : "Not Available"
        },
        { id: "Inactive date", 
          appealTableInfo: moment(this.detailInfo.licenseDateInactive).isValid() ? moment(this.detailInfo.licenseDateInactive).format('MMM DD, yyyy') : "Not Available"
        },
        // { id: "Contact", 
        //   appealTableInfo: this.detailInfo.licenseContact
        // },
        { id: "Business mailing address", 
          appealTableInfo: [ this.detailInfo.licenseContact, ...this.detailInfo.licenseContactAddress ]
        },
        { id: "Owner contact address", 
          appealTableInfo: this.detailInfo.ownercontact1[0] ? this.detailInfo.ownercontact1 : ''
        },
        { id: "Owner contact address 2", 
          appealTableInfo: this.detailInfo.ownercontact2[0] ? this.detailInfo.ownercontact2 : ''
        },
        { id: "Contact type", 
          appealTableInfo: this.detailInfo.licenseContactType
        },
      ]
      return tableInfo;
    }
  },
  methods: {
    clickBackButton(){
      this.$store.commit('closeDetail');
    },
    licenseTableData({item}){
      // console.log(item)
      const constItem = item;
      let tableData = [];
      const idList = ['date', 'decision', 'provisio'];
      idList.forEach( each => {
        // console.log(each)
        let row = new Object();
        row.id = each
        row.appealTableInfo = constItem[each]
        tableData.push(row);
      });
      // console.log("Table data for license: ", tableData)
      return tableData;
    },
    pluralize(item){
      return item > 1 ? item + " Units" : item + " Unit"
    }
  },
}
</script>
<style lang="scss">

@media screen and (max-width: 768px) {
  .license-detail-box>div.is-3 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div.license-date, .bottom-right-link {
      text-align: left;
      flex: 100%;
    }
    .bottom-right-link {
      float: right;
    }
  }
}


.columns:last-child {
  margin-bottom: auto !important;
}

.detail-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
}

.detail-button {
  margin-top: 20px;
}

.no-header th {
  display: none !important;
}

//  CSS for grey header-box in license detail page

.detail-container .license-detail-box {
  background-color: $ben-franklin-blue-light;
  margin: 0;
  padding: 15px 5px 15px 25px;
  clear: both;
  // & .column {
  //   padding: 0;
  // }
  .license-title {
    text-transform: uppercase;
  }
  .license-number {
    text-transform: uppercase;
    padding: 5px 0 15px 0;
  }
  .license-date {
    text-align: right;
    padding-right: 30px;
  }
  .bottom-right-link {
    right: 15px;
    bottom: 15px;
  }

}

// .license.table-id.has-text-weight-bold {
//   text-transform: capitalize;
// }

.table-id.has-text-weight-bold {
  width: 35%;
}

div.is-pulled-right.VueTables__limit {
   display: none;
}

</style>